import { store } from 'Models/Store';

/**
 * Whether the signed-in user may change the quantity of a restricted add-on.
 *
 * The same question `ApplyAddOnsUseCase` asks on the server before it accepts a change to a
 * restricted option, so the picker offers exactly what the server would accept. Previously a bare
 * staff check, which is the same set of people right up until someone is granted the capability
 * individually — at which point the server would have taken the change and the wizard would never
 * have offered it.
 *
 * Wrapped in a named function rather than inlined at the six call sites because the name is the
 * point: `store.isStaff` at an add-on counter reads as a fact about the user, where this reads as
 * the rule being applied.
 */
export function canAdjustRestrictedAddOns(): boolean {
	return store.can('AdjustRestrictedAddOns');
}
